// The screen shown when the app fails to start at all.
//
// Framework-free and tiny, like gate.ts next to it, and for a stricter reason:
// this runs when the app bundle is exactly what did not load. Nothing here may
// depend on anything the failure could have taken with it — no Svelte, no i18n
// dictionaries, no database. The markup and both languages' copy already sit in
// index.html; this only picks one and reveals it.

let shown = false;

/// Reveal the failure screen. Safe to call more than once — a failed launch
/// usually produces several errors, and the user should see one screen.
export function showBootError(reason: unknown): void {
  // Console first, and outside the guard: later errors are often the useful
  // ones, and this is the only trace a phone leaves behind.
  console.error('[boot] the app failed to start', reason);
  if (shown) {
    return;
  }
  const screen = document.getElementById('boot-error');
  if (screen === null) {
    return;
  }
  shown = true;

  // The splash is what the user is staring at; it has to go first, or the error
  // screen appears behind it.
  document.getElementById('splash')?.remove();

  const lang = navigator.language.toLowerCase().startsWith('pl') ? 'pl' : 'en';
  document.documentElement.lang = lang;
  const block = screen.querySelector<HTMLElement>(`.boot-error-lang[data-lang="${lang}"]`);
  if (block !== null) {
    block.hidden = false;
  }
  for (const button of screen.querySelectorAll<HTMLButtonElement>('.boot-error-retry')) {
    // A plain reload is the honest retry: with the network back, the shell is
    // re-fetched and the service worker gets another chance to install.
    button.addEventListener('click', () => location.reload());
  }
  screen.hidden = false;
}
